import { getItemWebStorage } from "../features/webStorageSaver";
import { store } from "../stateManagement/store";

export async function fetchObjectGeometry(
    urlType: string,
    objectType: string,
    objectId: string,
    options?: { signal?: AbortSignal }
) {
    const token = store.getState().auth.tokens.app
    const currentApiUrl = getItemWebStorage("currentApiUrl")
    let errorFlag = false
    let successFlag = false
    let response: any
    let cleanedText: any
    try {
        response = await fetch(`${currentApiUrl}/${urlType}/${objectType}(${objectId})/GeometryText`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`
            },
            signal: options?.signal,
        });
        if (response.ok) {
            successFlag = true
        }
        else {
            errorFlag = true
        }
    }
    catch (error: any) {
        // Реальная отмена запроса (AbortController) не является ошибкой для UI
        if (error?.name === 'AbortError') throw error
        errorFlag = true
    }
    if (response) {
        let raw = ''
        try {
            raw = await response.text();
        } catch (error: any) {
            if (error?.name === 'AbortError') throw error
            errorFlag = true
        }

        let defaultText = raw;
        try {
            const json = JSON.parse(raw);
            if (json && typeof json === 'object' && 'value' in json) {
                defaultText = json.value;
            }
        } catch { /* не JSON — оставляем текст */ }

        cleanedText = (defaultText ?? '').replace(/\0/g, '');
    }
    return { data: cleanedText, isError: errorFlag, isSuccess: successFlag }
}

export async function fetchCoordsToPosition(roadId: any, pathId: any, latitude: any, longitude: any) {
    const currentApiUrl = getItemWebStorage("currentApiUrl")
    const token = store.getState().auth.tokens.app
    let response: any
    try {
        response = await fetch(`${currentApiUrl}/address/coordsToPosition?PathId=${pathId}&RoadId=${roadId}&Latitude=${latitude}&Longitude=${longitude}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`
            },
        });
    } catch (error) {
        console.error(error)
    }
    if (response) {
        const data: any = await response.json()
        return data
    }
}